import { render, staticRenderFns } from "./showcase-list.vue?vue&type=template&id=f1290850&scoped=true"
import script from "./showcase-list.vue?vue&type=script&lang=js"
export * from "./showcase-list.vue?vue&type=script&lang=js"
import style0 from "./showcase-list.vue?vue&type=style&index=0&id=f1290850&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1290850",
  null
  
)

export default component.exports